export default (
  {
    title = '',
    centerText = '',
    useCenterText = true,
  }
) => {
  return {
    useCenterText: centerText !== '' && useCenterText,
    centerText: centerText,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: title !== '',
        position: 'bottom',
        text: title,
        padding: {
          top: 15,
          bottom: 0,
        },
      },
      tooltip: {
        enabled: false,
      },
    },
    cutout: '80%',
  }
};
